module.exports = __webpack_public_path__ + "img/linkedin-in.d6452fb2.svg";